import { filterStaticTabs } from './filterStaticTabs';
/** Extracted this logic to keep the AppHostComponent simple */
export const filterAppDefinitionStaticTabs = (appDefinition) => {
    if (!appDefinition)
        return appDefinition;
    return Object.assign(Object.assign({}, appDefinition), { staticTabs: filterStaticTabs(appDefinition.staticTabs) });
};
//# sourceMappingURL=filterAppDefinitionStaticTabs.js.map